import React from 'react'
import { useMemo,useState, useEffect } from "react"
import "./Karty_new_form.css";
import { authHeader } from '../_helpers';
import { useTable, useSortBy, useGlobalFilter} from "react-table";
//import GlobalFilter from "../_components/GlobalFilterUziv"
import { AiOutlineClear } from "react-icons/ai";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/cs';
import { history } from '_helpers';


const Karty_new_form = () => {
    const baseUrl = `${process.env.REACT_APP_API_URL}`;
    const user = JSON.parse(localStorage.getItem('user'));
    const firma = JSON.parse(localStorage.getItem('firma'));
    const [typoptions,setTypoptions]=useState();
    const [typvalues,setTypvalues]=useState([]);
    const [skupoptions,setSkupoptions]=useState();
    const [skupvalues,setSkupvalues]=useState([]);
    const [datumOd, setDatumOd] = useState();
    const [datumDo, setDatumDo] = useState();
    const [cleared, setCleared] = useState(false);

    

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([]);
   
    const [klic, setKlic] = useState({
        klic_fi: '',
        klic_ID: '',
        klic_cislo: '',
        klic_popis: '',
        klic_skup: '',
        klic_typ: '',
        klic_stav: '',
        klic_OD: '',
        klic_DO: '' 
    });

    const handleTypSelectChange = (event) => {
              setTypoptions(event.target.value);
    }
      
    const fetchDropDownTyp = () => {
              console.log("fetchdropdownTyp");
                  //const firma = JSON.parse(localStorage.getItem('firma'));
              
      
                  const requestOptions = {
                      method: 'GET',
                      headers: authHeader()
                  };
                  fetch(process.env.REACT_APP_API_URL+"/api/private/allkltyp/"+user.u_fi, requestOptions).then((data)=>data.json()).then((val)=>setTypvalues(val)) 
              
    }

    const handleSkupSelectChange = (event) => {
            setSkupoptions(event.target.value);
    }
    
    const fetchDropDownSkup = () => {                          
                const requestOptions = {
                    method: 'GET',
                    headers: authHeader()
                };
                fetch(process.env.REACT_APP_API_URL+"/api/private/skupiny/"+user.u_fi+"/all", requestOptions).then((data)=>data.json()).then((val)=>setSkupvalues(val)) 
            
    }    

    function handleSubmit(e) {
        e.preventDefault();
        if (skupoptions == "default" || typeof(skupoptions) == 'undefined') {
            alert("Zvolte skupinu klíče!");
        } else {
            if (typoptions == "default" || typeof(typoptions) == 'undefined') {
                alert("Zvolte funkci klíče");
            } else {
                klic.klic_OD = new Date(datumOd).toLocaleDateString('zh-Hans-CN') + " 00:00";
                klic.klic_DO = new Date(datumDo).toLocaleDateString('zh-Hans-CN') + " 23:59";     
                if (typeof(datumOd) == 'undefined' || datumOd == null || typeof(datumDo) == 'undefined' || datumDo == null || klic.klic_OD == 'Invalid Date 00:00' || klic.klic_DO == 'Invalid Date 23:59') {
                    alert("Špatně zvolené datum!");      
                } else {   
                    const firma = JSON.parse(localStorage.getItem('firma'));
                    klic.klic_fi = firma[0].fi_ID;
                    klic.klic_stav = '1';
                    
                    var prac = skupoptions.substring(skupoptions.indexOf(":")+1);
                    klic.klic_skup= prac;

                    var prac2 = typoptions.substring(typoptions.indexOf(":")+1);
                    klic.klic_typ= prac2;

                    console.log(klic);
                    const requestOptions = {
                        method: 'POST',
                        headers: { ...authHeader(), 'Content-Type': 'application/json' },
                        body: JSON.stringify(klic)
                    };
                    clearForm();
                    
                    //console.log(process.env.REACT_APP_API_URL);
                    //console.log(JSON.stringify(zarizeni));
                    return fetch(`${process.env.REACT_APP_API_URL}/api/private/newklic`, requestOptions).then(handleResponse);
                }
            }
        }
    }

    function handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            if (response.status === 200) {
                console.log("POSTED")
                //window.location.href = "/#/karty";
                history.navigate('/moznosti');
            } else {console.log("ERR"); alert("Špatně zvolené jméno nebo heslo, zkuste znovu.");}
            if (!response.ok) {
                if (response.status === 401) {
                    // auto logout if 401 response returned from api
                    //logout();
                    //location.reload(true);
                }
                if (response.status === 200) {
                    console.log("POSTED")
                }
    
                const error = (data && data.message) || response.statusText;
                return Promise.reject(error);
            }
    
            return data;
        });
    }

    const clearForm = () => {
        setKlic({
            klic_fi: '',
            klic_ID: '',
            klic_cislo: '',
            klic_popis: '',
            klic_skup: '',
            klic_typ: '',
            klic_stav: '',
            klic_OD: '',
            klic_DO: '' 
        });
        setSkupoptions();
        setSkupvalues([]);
        setTypoptions();
        setTypvalues([]);
        setLoading(true);
        setTimeout(function() {
        
        setLoading(false);
      }, 1000); 
    }

    return (
      <>
            <form name="formZarizeniNewKar" onSubmit={handleSubmit}>
                <section id="formInfoKar">
                            
                        <label className='lblZarizeniNewKar'>
                            <input 
                                type="text" 
                                name="z_jmeno"
                                value={klic.klic_popis} 
                                onChange={(e) =>
                                    setKlic({ ...klic, klic_popis: e.target.value })
                                }                                                                
                                className="inputKlientiKar"
                                required="required"
                                placeholder=" "
                            />
                            <span>Název</span>
                        </label>
                        
                        <label className='lblZarizeniNewKar'>
                            <input 
                                type="text" 
                                name="z_par"
                                value={klic.klic_cislo} 
                                onChange={(e) =>
                                    setKlic({ ...klic, klic_cislo: e.target.value })
                                }                                              
                                className="inputKlientiKar"
                                required="required" 
                                placeholder=" "
                            />
                            <span>Číslo klíče</span>
                        </label>

                        <select className='inputTypKar' onChange={handleSkupSelectChange} onClick={fetchDropDownSkup}>
                        <option value="default">Zvolte skupinu. . .  </option>
                        {
                            skupvalues.map((opts,i)=><option key={i}>{opts.s_name+",   ID:"+opts.s_id}</option>)
                        }
                        </select>

                        <select className='inputTypKar' onChange={handleTypSelectChange} onClick={fetchDropDownTyp}>
                        <option value="default">Zvolte funkci. . .  </option>
                        {
                            typvalues.map((opts,i)=><option key={i}>{opts.cis_pop+",   ID:"+opts.cis_id}</option>)
                        }
                        </select>
                        <section className='formDatesRzKar'>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="cs">

                        <DatePicker 
                            className="datumOD"
                            name="klic_OD"
                            label="Platnost OD"
                            //value={datumOd}
                            maxDate={datumDo}
                            disablePast={true}
                            
                            onChange={(newValue) => setDatumOd(newValue)}
                            required="required"
                            format="DD/MM/YYYY"
                            slotProps={{
                                field: { clearable: true, onClear: () => setCleared(true) },
                            }}
                        />
                        <DatePicker
                            className='datumDORz'
                            name="klic_DO"
                            label="Platnost DO"
                            //value={klic.klic_DO}
                            minDate={datumOd}
                            disablePast={true}
                            onChange={(newValue) => setDatumDo(newValue)}
                            required="required"
                            format="DD/MM/YYYY"
                            slotProps={{
                                field: { clearable: true, onClear: () => setCleared(true) },
                            }}
                        />

                        </LocalizationProvider>
                        </section>    
                        
                             
                        <section className="formButtonsNewZarKar">
                            <button type='submit' className='btnKlientiSubmitNewZarKar'>
                                Odeslat
                            </button>
                            <button className='btnClr' onClick={clearForm}>
                            <AiOutlineClear />
                            </button>       

                        </section>  
                </section>
                
            </form>
      </>
    )
}

export default Karty_new_form;